// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {CourseModuleLayout} from 'app_components/modules/admin/course'
// @end

// @import events
// @end

// @import utils
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import { I18nUtil } from 'app_utils/i18n'
// @end

// @import services
import CourseService from 'app_services/admin/course/courseService'
import ReactSelectService from 'app_services/components/reactSelectService'
// @end

// @import types
// @end

// @ADD Component types
interface ICourseModuleProps {
  onHandleSubmit?: (data: any) => void
  editData?: any
  viewer: boolean
}
interface ICourseModuleState {
  customErrors: any
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class CourseModule extends Component<ICourseModuleProps, ICourseModuleState> {

  private reactSelectService: ReactSelectService
  private courseService: CourseService
  private screenNotifications: ScreenNotificationsUtil
  private i18nUtil: I18nUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: ICourseModuleProps) {
    super(props)
    this.state = {
      customErrors: null
    }

    this.reactSelectService = new ReactSelectService()
    this.courseService = new CourseService()
    this.screenNotifications = new ScreenNotificationsUtil()
    this.i18nUtil = new I18nUtil()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods
  onSubmit = async (data: any) => {
    this.setState({customErrors: null})
    let customErrors: any = {}

    if (data.platform_video || (data.url_video && data.url_video !== '')) {
      if (!data.platform_video) {
        customErrors.platform_video = this.i18nUtil.getTranslate('modules.courses.form.platform_video')
      }
      if (!data.url_video || (data.url_video && data.url_video === '')) {
        customErrors.url_video = this.i18nUtil.getTranslate('modules.courses.form.url_video')
      }
    } else {
      data.platform_video = ""
      data.url_video = ""
    }

    // @INFO: Si existen campos con error retorno
    if (Object.keys(customErrors).length > 0) {
      this.setState({customErrors})
      return false
    }

    if (data.platform_video) {
      data['platform_video'] = this.reactSelectService.formatReactSelectResponse(data.platform_video)
    }
    if (data.formationType) {
      data['formationType'] = this.reactSelectService.formatReactSelectResponse(data.formationType)
    }
    if (data.filterCategories?.length) {
      data['filterCategories'] = this.reactSelectService.formatReactSelectResponse(data.filterCategories)
    } else {
      data['filterCategories'] = []
    }

    const courseResponse = await this.courseService.insertOrUpdate(
      data,
      (this.props.editData && this.props.editData._id) ? `update/${this.props.editData._id}` : 'create'
    )

    if (courseResponse) {
      let screen_notification_label = 'components.screen_notifications.add'
      if (this.props.editData && this.props.editData._id) {
        screen_notification_label = 'components.screen_notifications.update'
      }

      this.screenNotifications.fireToast(
        {
          message: `${this.i18nUtil.getTranslate(screen_notification_label)}`,
        },
        {
          position: 'bottom-right',
        }
      )

      if (this.props.onHandleSubmit) {
        this.props.onHandleSubmit(courseResponse)
      }
    }

    // this.setState({ status: null })
  }

  // /**
  //  * @INFO Obtener segundos de texto
  //  * @param inputValue
  //  */
  // getSecondsFromDuration = (inputValue: string) => {
  //   const auxVector = inputValue.split(' ')
  //   let seconds: number = 0
  //   if(auxVector.length){
  //     auxVector.forEach(item => {
  //       if(item.includes('h')){
  //         const hours = Number(item.replace('h', ''))
  //         seconds += hours*3600
  //       }else if(item.includes('m')){
  //         const minutes = Number(item.replace('m', ''))
  //         seconds += minutes*60
  //       }else if(item.includes('s')){
  //         seconds += Number(item.replace('s', ''))
  //       }
  //     })
  //   }
  //   return seconds
  // }

  render() {
    return(
      <CourseModuleLayout
        {...this.props}
        onHandleSubmit={this.onSubmit}
        customErrors={this.state.customErrors}
        viewer={this.props.viewer}
      />
    )
  }
}

export default connect(mapStatesToProps)(CourseModule)
